import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '@material-ui/core/styles';
// import ErrorIcon from '@material-ui/icons/Error';
// import WarningIcon from '@material-ui/icons/Warning';
// import InfoIcon from '@material-ui/icons/Info';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import ContactSupportIcon from '@material-ui/icons/ContactSupport';
// import KeyboardIcon from '@material-ui/icons/Keyboard';
// import DangerousInnerHtml from '../DangerousInnerHtml/DangerousInnerHtml';
import CustomButton from 'components/CustomInput/Button/index';

const useStyles = makeStyles(theme => ({
    msgBoxWrapper: {
        minWidth: '350px',
        maxHeight: '50%',
        overflow: 'auto'
    },
    titleIcon: {
        marginRight: '5px',
        verticalAlign: 'text-bottom'
    },
    error: {
        color: theme.palette.error.main
    },
    warning: {
        color: theme.palette.warning.main
    },
    info: {
        color: theme.palette.primary.main
    },
    success: {
        color: theme.palette.success.main
    },
    confirm: {
        color: theme.palette.primary.main
    },
    input: {
        color: theme.palette.primary.main
    }

    
}));





const MsgBox = (props) => {
    const classes = useStyles();
    // let TitleIcon = null;
    // const type = props.type ? props.type : 'info';

    // switch (type) {
    //     case "error":
    //         TitleIcon = ErrorIcon;
    //         break;
    //     case "warning":
    //         TitleIcon = WarningIcon;
    //         break;
    //     case "info":
    //         TitleIcon = InfoIcon;
    //         break;
    //     case "success":
    //         TitleIcon = CheckCircleIcon;
    //         break;
    //     case "confirm": 
    //         TitleIcon = ContactSupportIcon;
    //         break;
    //     case "input":
    //         TitleIcon = KeyboardIcon;
    //         break;
    //     default: 
    //         TitleIcon = InfoIcon;
    //         break;
    // }

    const { footerActions, closePopup, message, isHTML } = props;

    return (
        <Dialog
            open={true}
            onClose={closePopup}
            maxWidth="md"
            PaperProps={{
                className: classes.msgBoxWrapper,
                name:"MsgBox"
            }}
            name="MsgBox"
        >
            {/* <DialogTitle className={classes[type]}>
                <TitleIcon className={classes.titleIcon} />
                {props.title ? props.title : type.toUpperCase()}
            </DialogTitle> */}
                {props.title ? props.title : null}
            <DialogContent name="MsgBoxContent">
                {
                    Array.isArray(message)? 
                    message.map((val, idx) => {
                        return (
                            isHTML ?
                                null :
                                // <DangerousInnerHtml html={val} key={idx}/>:
                                // <div dangerouslySetInnerHTML={{ __html: val }} key={idx} /> :
                                <DialogContentText key={idx}>{val}</DialogContentText>
                        )
                            
                    }):
                        isHTML ?
                            null :
                            // <DangerousInnerHtml html={message} /> :
                            // <div dangerouslySetInnerHTML={{ __html: message }}/> :
                            <DialogContentText>{message}</DialogContentText>
                }
            </DialogContent>
            <DialogActions name="MsgBoxActions">
                <React.Fragment>
                    {footerActions.map(item => 
                        <CustomButton key={item.label} name={`Btn_${item.label}`} onClick={item.clicked ? item.clicked : closePopup} color={item.color ? item.color : "primary"}>
                            {item.label}
                        </CustomButton>
                    )}
                </React.Fragment>
                
            </DialogActions>
        </Dialog>
    )
}

MsgBox.defaultProps = {
    footerActions: [
        {
            label: 'Confirm'
        }
    ]
}

export default MsgBox;